import { Styles, css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

import ArrowLeftIcon from '../icon/generated/ArrowLeftIcon';
import ArrowRightIcon from '../icon/generated/ArrowRightIcon';

interface Props {
  onPrev?: () => unknown;
  onNext?: () => unknown;
  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;
  css?: Styles;
}

export const Navigator = ({ onPrev, onNext, isPrevDisabled, isNextDisabled, css: cssProps }: Props) => {
  if (isPrevDisabled && isNextDisabled) return null;
  return (
    <div className={css(hstack.raw({ gap: 4 }), cssProps)}>
      <button
        type='button'
        onClick={() => {
          onPrev?.();
        }}
        className={navigatorCss}
        disabled={isPrevDisabled}
        aria-label='prev'
      >
        <ArrowLeftIcon size={20} />
      </button>
      <button
        type='button'
        onClick={() => {
          onNext?.();
        }}
        className={navigatorCss}
        disabled={isNextDisabled}
        aria-label='next'
      >
        <ArrowRightIcon size={20} />
      </button>
    </div>
  );
};

const navigatorCss = css({ p: 6, color: 'content.default.level-5', _disabled: { color: 'content.default.level-1' } });

export function paginationHelper({
  current,
  per,
  total,
  onChange,
}: {
  current: number;
  per: number;
  total: number;
  onChange: (page: number) => void;
}) {
  const isFirstPage = current === 0;
  const isLastPage = total <= (current + 1) * per;
  return {
    isPrevDisabled: isFirstPage,
    isNextDisabled: isLastPage,
    onPrev() {
      if (isFirstPage) return;
      onChange(current - 1);
    },
    onNext() {
      if (isLastPage) return;
      onChange(current + 1);
    },
  };
}
